'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

declare global {
  interface Window {
    _paq?: Array<Array<string | number | boolean>>;
  }
}

export function NotFoundTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Create the _paq queue if Matomo's init script hasn't run yet
    // (strategy="afterInteractive" may execute after this useEffect).
    // Matomo's init script uses `window._paq = window._paq || []` so
    // it will adopt our array and process queued commands when it loads.
    (window._paq = window._paq || []).push(['trackEvent', 'Error', '404', pathname]);

    // First-party fallback: reach the server even when Matomo is blocked by an
    // adblocker or the visitor is a non-JS-tracking bot. Same-origin, so no CSP
    // change needed. Best-effort — sendBeacon failure must never break the page.
    try {
      const payload = JSON.stringify({ type: '404', path: pathname });
      navigator.sendBeacon?.('/api/rum', new Blob([payload], { type: 'application/json' }));
    } catch {
      // ignore — beacon is a best-effort supplement to Matomo
    }
  }, [pathname]);

  return null;
}
